import React from 'react';
import { useMemo } from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import BlackDuckCredentialsForm from './BlackDuckCredentialsForm';
import BlackDuckMappingForm from './BlackDuckMappingForm';
import _ from 'lodash';
import { CellRenderers } from 'utils/tableUtils';
import { DELIMITER } from './BlackDuckMappingForm';
import ContentOverlay from 'components/ContentOverlay';

const BlackDuckConfigListing = (props) => {
    
    const columns = useMemo(() => [{
        title: "Project",
        dataIndex: "project",
        width: 240,
        render: (project, record) => {
            if(_.isEmpty(project)) {
                return CellRenderers.VALUE_OR_NA(project)
            }
           
            const projectNames = _.split(project, ',');
            const projectObj = {}
               
            _.forEach(projectNames, project => {
                const index = project.lastIndexOf(DELIMITER)
                const _project = project.substring(0, index === -1 ? undefined : index);
                if(index !== -1){
                  const references = project.substring(index + 1, project.length);
                  projectObj[_project] = _.split(references.replace(/;/g, ', '), ',')
                }else if(record?.project_version){
                    projectObj[_project] = _.split(record?.project_version, ',')
                }else{
                    projectObj[_project] = undefined
                }
                
            })

            const renderName = Object.keys(projectObj).map(item => projectObj[item] ? `${item} - [${projectObj[item]}]` : item )


            const content = renderName.map(item => <p>{item}</p>)

            return <ContentOverlay content={content} minHeight={40}/>
        } 
    }], [])

    return (
        <GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={BlackDuckMappingForm}
        CredentialsForm={BlackDuckCredentialsForm}
        extraColumns={columns}
     />
    );
}

export default BlackDuckConfigListing;
